import { Property, PropertyGroup } from '@features/product/typings';

export default function mergePropertyGroups(propertyGroups: PropertyGroup[]): PropertyGroup {
  const mergedGroup = propertyGroups.reduce(
    (acc, propertyGroup) => {
      acc.properties = removeDuplicatedProperties(acc.properties.concat(propertyGroup.properties));
      return acc;
    },
    { title: 'Combined Group', properties: [] }
  );

  return mergedGroup;
}

function removeDuplicatedProperties(properties: Property[]) {
  const propertyIdSet = new Set();
  return properties.filter(property => {
    if (propertyIdSet.has(property.propertyId)) {
      return false;
    } else {
      propertyIdSet.add(property.propertyId);
      return true;
    }
  });
}
